import { purchases } from './role'

export const queries = {
  purchases,
}
export default queries
